export default {
    dashboardSidebarLabel: "Tableau de bord",
    resourcesSidebarLabel: "Resources",
    practiceSidebarLabel: "Entrainement",
    resultSidebarLabel: "Résultats",
    notificationSidebarLabel: "Notifications",
    settingsSidebarLabel: "Paramètres",
}